
import { defineComponent } from "vue";
import PlanOrderResultJournal from "@/components/journals/PlanOrderResultJournal/PlanOrderResultJournal.vue";
import PlanPackageResultJournal from "@/components/journals/PlanPackageResultJournal/PlanPackageResultJournal.vue";
import PlanPackageResultRollupJournal from "@/components/journals/PlanPackageResultJournal/PlanPackageResultRollupJournal.vue"
import PlanContainerResultJournal from "@/components/journals/PlanContainerResultJournal/PlanContainerResultJournal.vue";
import DxButton from "devextreme-vue/button";
import router from "@/router";
import api from "@/services/api";
import { PlanState } from "./enums";
import store from "@/store";

export default defineComponent({
  components: {
    PlanOrderResultJournal,
    PlanPackageResultJournal,
    PlanPackageResultRollupJournal,
    PlanContainerResultJournal,
    DxButton,
  },
  props: {
    parentModel: { required: true },
    isCalculation: { required: true },
  },
  computed: {
    isPlanCompleted() {
      return this.parentModel.state === PlanState.Completed;
    },
    isPlanNotFound() {
      return this.parentModel.state === PlanState.NotFound;
    },
    time() {
      if (this.seconds == 0) return "0 сек";
      else return this.getTime(this.seconds);
    },
  },
  methods: {
    startTimer() {
      this.interval = setInterval(this.incrementTime, 1000);
    },
    incrementTime() {
      this.seconds += 1;
    },
    changeView(isRollupView: any){
      this.isRollupView = isRollupView;
    },
    onButtonClick() {
      if (this.loading) this.onStop();
      else this.onGenerateReport();
    },
    onStop() {
      this.stopping = true;
      this.loading = false;
      clearInterval(this.interval);
      this.seconds = 0;
    },
    onGenerateReport() {
      router.push({
        name: "loadingReport",
        params: {
          planId: `${this.parentModel.id}`,
          planDescription: `${this.parentModel.name}`,
        },
      });
    },
    getTime(seconds: any){
      var hr = Math.floor(seconds / 3600);
      var min = Math.floor(seconds / 60) - hr * 60;
      var sec = seconds % 60;

      return (
        (hr != 0 ? hr + " час " : "") +
        (min != 0 ? min + " мин " : "") +
        (sec != 0 ? sec + " сек" : "")
      );
    },
    async getSchemeCount(planId: any) {
      const { data } = await api.get(`/LoadingReport/GetSchemeCount`, {
        params: {
          planId: planId,
        },
      });
      return data;
    },
    async onDownload() {
      const reportData = (store as any).state.reportData.reportData;
      let schemeCount = await this.getSchemeCount(this.parentModel.id);

      if (schemeCount) {
        const time = Math.round(2 * schemeCount);
        this.timeMessage = "\nПриблизительное время формирования отчета - " + this.getTime(time);
      } else {
        this.timeMessage = "";
      }

      this.loading = true;
      this.stopping = false;
      this.startTimer();
      let startTime = new Date().getTime();
      const { data } = await api.get(`/LoadingReport/GetReport`, {
        responseType: "blob",
        params: {
          planId: `${this.parentModel.id}`,
        },
      });
      if (this.stopping) return;
      let blob = new Blob([data], { type: "application/octet-stream" });
      let link = document.createElement("a");
      if (this.stopping) return;
      link.href = window.URL.createObjectURL(blob);
      if (this.stopping) return;
      link.download = `Report.pdf`;
      link.click();
      link.remove();
      this.loading = false;
      this.timeMessage = "";
      let endTime = new Date().getTime();
      clearInterval(this.interval);
      this.seconds = 0;

      if (this.schemeCount != 0) {
        const temp = {
          data: {
            generationTime: reportData.generationTime
              ? reportData.generationTime
              : null,
            generationTimePdf: (endTime - startTime) / (1000 * schemeCount),
          },
        };
        store.dispatch("reportData/setReportData", temp);
      }
    },
  },
  data() {
    return {
      seconds: 0,
      isRollupView: false,
      stopping: false,
      loading: false,
      timeMessage: "",
    };
  },
});
